import { render, staticRenderFns } from "./LambdaApiDeveloper.vue?vue&type=template&id=2255d7f4&scoped=true&"
import script from "./LambdaApiDeveloper.vue?vue&type=script&lang=js&"
export * from "./LambdaApiDeveloper.vue?vue&type=script&lang=js&"
import style0 from "./LambdaApiDeveloper.vue?vue&type=style&index=0&id=2255d7f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2255d7f4",
  null
  
)

export default component.exports